import Modal from '@mui/material/Modal/Modal';
import { FC } from 'react';
import Box from '@mui/material/Box/Box';
import { zIndex, colors } from 'styles';
import { Backdrop } from '@mui/material';

type FormModalProps = { onClose: () => void; isOpen: boolean; formUrl: string };

export const FormModal: FC<FormModalProps> = ({ isOpen, onClose, formUrl }) => {
  return (
    <Modal
      sx={{
        zIndex: zIndex.modal,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      open={isOpen}
      onClose={onClose}
      aria-labelledby="form-modal-title"
      aria-describedby="form-modal-description"
      slots={{
        backdrop: (props) => (
          <Backdrop
            {...props}
            sx={{
              backdropFilter: 'blur(5px)',
              backgroundColor: 'rgba(0,0,0,0.2)',
            }}
          />
        ),
      }}
    >
      <Box
        sx={{
          backgroundColor: colors.white,
          minHeight: '150px',
          height: '100%',
          maxHeight: '600px',
          overflow: 'auto',
          width: '100%',
          maxWidth: {
            sm: '722px',
            xxs: 'calc(100% - 40px)',
          },
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          padding: '0',
        }}
      >
        <iframe
          src={formUrl}
          width="100%"
          height="100%"
          style={{
            border: 'none',
            minHeight: '500px',
          }}
          title="Form"
        />
      </Box>
    </Modal>
  );
};

